<template>
  <div class="row pr-2">
    <div class="col-auto mt-3 text-center">
      <span class="text-success">
        {{ percentage.toLocaleString("pt-BR") }}%
      </span>
    </div>
    <div class="progress mt-4 col p-0">
      <div
        class="progress-bar bg-success"
        :style="{
          width: percentage + '%'
        }"
      >
      </div>
    </div>
    <div v-if="percentage > 100" class="progress mt-4 col-1 p-0 ">
      <div
        class="bg-info progress-bar-striped progress-bar-animated"
        style="width: 100%"
      >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PercentageBar',
  props: {
    value: {
      type: Number,
      required: true
    },
    maxValue: {
      type: Number,
      required: true
    },
  },
  computed: {
    percentage() {
      if (!this.maxValue || this.maxValue == 0) return 0

      return (100 * (this.value || 0) / (this.maxValue || 0)).toFixed(2) || 0
    }
  }
}
</script>